/*
  Product view/click tracking. Fires anonymous, fire-and-forget beacons at
  hostinger-shopify/api/tracking/track.php — the actual Shopify metafield
  write happens later, in bulk, via that module's sync-metafields.php cron.

  Loaded once from layout/theme.liquid (not per-card), same reasoning as
  assets/wishlist.js: a <script> rendered inside a snippet that later gets
  swapped into the page via container.innerHTML never executes, so this
  can't live inline in a card snippet — it has to be a real global script.

  Signal definitions:
  - View: a hover (with a short dwell, so a mouse just passing over a grid
    doesn't count) on any [data-track-product-id] element (product cards,
    catalog-card top-3 thumbnails, the Wishlist page's cards), OR landing on
    the product's own page. Fires at most once per product per page view
    either way.
  - Click: clicking a [data-track-product-id] element. Always implies a
    view too (you can't click something without having seen it), fired
    together with the click.

  A click sets a short-lived sessionStorage flag so the destination product
  page's own page-load view is skipped for that visit — otherwise a single
  click-through would count as a view twice (once from the click, once from
  the page loading). A direct visit with no preceding card click (search,
  a bookmark, a shared link) still gets its own page-load view as normal.
*/
(function () {
  var TRACK_URL = 'https://admin.seuyco.com/shopify/api/tracking/track.php';
  var HOVER_DWELL_MS = 400;
  var CLICK_VIEW_FLAG_TTL_MS = 15000;
  var CLICK_VIEW_FLAG_PREFIX = 'sf-click-view-';

  // Once-per-pageview guard, keyed "productId:type" — applies to both
  // hover-views and click-views/clicks alike, so re-hovering or accidentally
  // double-clicking the same card doesn't inflate anything.
  var firedThisPage = {};

  function send(productId, catalogId, type) {
    productId = parseInt(productId, 10);
    if (!productId) return;
    catalogId = parseInt(catalogId, 10) || null;

    var payload = JSON.stringify({ product_id: productId, catalog_id: catalogId, type: type });
    fetch(TRACK_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: payload,
      keepalive: true
    }).catch(function () {});
  }

  function sendOnce(productId, catalogId, type) {
    var key = productId + ':' + type;
    if (firedThisPage[key]) return;
    firedThisPage[key] = true;
    send(productId, catalogId, type);
  }

  function clickFlagKey(productId) {
    return CLICK_VIEW_FLAG_PREFIX + productId;
  }

  // Called when a card click fires (or already covered) a view for this
  // product, so the product page it navigates to knows not to record its
  // own page-load view for the same visit.
  function markClickView(productId) {
    try { sessionStorage.setItem(clickFlagKey(productId), String(Date.now())); } catch (e) {}
  }

  function consumeClickViewFlag(productId) {
    try {
      var key = clickFlagKey(productId);
      var raw = sessionStorage.getItem(key);
      if (!raw) return false;
      sessionStorage.removeItem(key);
      var ts = parseInt(raw, 10);
      return !!ts && (Date.now() - ts) < CLICK_VIEW_FLAG_TTL_MS;
    } catch (e) {
      return false;
    }
  }

  // ── Page-load view (product pages only) ──────────────────────────────
  var cfg = window.SYC_PRODUCT_TRACKING || {};
  if (cfg.productId) {
    if (consumeClickViewFlag(cfg.productId)) {
      // A card click on the previous page already recorded this view -
      // mark it as fired here too so nothing on this page (e.g. hovering a
      // related-products card for the same product) double-records it.
      firedThisPage[cfg.productId + ':view'] = true;
    } else {
      sendOnce(cfg.productId, cfg.catalogId, 'view');
    }
  }

  // ── Card click: counts as both a click and a view ────────────────────
  document.addEventListener('click', function (e) {
    var link = e.target.closest('[data-track-product-id]');
    if (!link) return;
    var productId = link.getAttribute('data-track-product-id');
    var catalogId = link.getAttribute('data-track-catalog-id');
    sendOnce(productId, catalogId, 'view');
    sendOnce(productId, catalogId, 'click');
    markClickView(productId);
  }, true);

  // ── Card hover: counts as a view, after a short dwell ────────────────
  // Delegated via mouseover/mouseout (mouseenter/mouseleave don't bubble),
  // using relatedTarget to tell "moved to a child within the same card"
  // (ignore) apart from "actually left the card" (cancel the pending timer).
  var hoverTimers = new WeakMap();

  document.addEventListener('mouseover', function (e) {
    var link = e.target.closest('[data-track-product-id]');
    if (!link || (e.relatedTarget && link.contains(e.relatedTarget))) return;
    if (hoverTimers.has(link)) return;

    var productId = link.getAttribute('data-track-product-id');
    var catalogId = link.getAttribute('data-track-catalog-id');
    var timer = setTimeout(function () {
      hoverTimers.delete(link);
      sendOnce(productId, catalogId, 'view');
    }, HOVER_DWELL_MS);
    hoverTimers.set(link, timer);
  });

  document.addEventListener('mouseout', function (e) {
    var link = e.target.closest('[data-track-product-id]');
    if (!link || (e.relatedTarget && link.contains(e.relatedTarget))) return;
    var timer = hoverTimers.get(link);
    if (timer) {
      clearTimeout(timer);
      hoverTimers.delete(link);
    }
  });
})();
